"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _SelectIcon = _interopRequireDefault(require("./SelectIcon"));
const _excluded = ["classes", "className", "IconComponent", "inputRef"];
const SelectInputNative = /*#__PURE__*/_react.default.forwardRef(function SelectInputNative(props, ref) {
  const {
      classes = {},
      className,
      IconComponent,
      inputRef
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("select", (0, _extends2.default)({
    className: (0, _clsx.default)(classes.root, classes.select, className)
  }, ref ? {
    ref: inputRef || ref
  } : {}, other)), IconComponent && /*#__PURE__*/_react.default.createElement(_SelectIcon.default, {
    classes: classes,
    IconComponent: IconComponent
  }));
});
var _default = exports.default = SelectInputNative;